import React from 'react';
import './about-us.scss';
import {Col, Container, Row} from 'react-bootstrap';

function AboutUs() {
  return (
    <div id="about" className="about-us pt50">
      <div className="clouds cloud1"></div>
      <div className="clouds cloud2"></div>
      <div className="clouds cloud3"></div>
      <div className="clouds cloud4"></div>
      <Container>
        <Row>
          <Col sm={12} className="mb50">
            <div className="section-title">Our Story</div>
            <h2>Welcome to Our Home</h2>
            <div className="p-sides">
              <div className="subtitle">Originally established as Amazing Cyprus Glamping Domes, our estate began as one of boutique dome destinations, welcoming travellers looking for something unique. Rather than a traditional resort, we share our home and gardens with those who appreciate nature, architecture and meaningful travel in a truly unique setting.
              </div>
              <p className="subtitle">
                Today, it is our private Mediterranean estate, surrounded by botanical gardens, hundreds of carefully planted trees, waterfalls, sculptures and peaceful outdoor spaces. Every corner of the property has been thoughtfully created with respect for nature, offering an atmosphere of privacy, authenticity and quiet relaxation.
              </p>

              <p className="mb40 d-none d-sm-block">
                Our garden domes remain an important part of the estate, allowing visitors to enjoy the beauty of the Cyprus countryside while experiencing the comfort of contemporary design.
              </p>

              {/*<ul className="list facilities">
                <li>One of the big designed maze in Europe</li>
                <li>Zeus  - one of the seven wonders of ancient world.</li>
                <li>Cinema on the air</li>
              </ul>*/}
            </div>
          </Col>

          <Col sm={12} className="what-we-have d-none d-sm-block">
            <Row>
              <Col md={5}>
                <Row>
                  <Col sm={6} md={12}>
                    <div className="block">
                      <div className="desc"><span>660</span> trees</div>
                      <div className="sub">and we are increasing them every year</div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="block">
                    <div className="desc"><span> 1</span></div>
                      <div className="sub">outside cinema</div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="block">
                      <div className="desc"><span> 7</span></div>
                      <div className="sub">Small waterfalls</div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <div className="block">
                      <div className="desc"><span>6</span></div>
                      <div className="sub">unique Marble statues</div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="block">
                      <div className="desc"><span>4</span></div>
                      <div className="sub">Original Domes</div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm={7} className="round-img d-none d-md-block"></Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/*<div className="video-section d-none d-md-block">
        <Container>
          <Row>
            <Col sm={12}>
              <h3 className="mb50">Visitors can trust that glamping “Amazing Glamping Domes” they uncover will provide a truly unique and unforgettable travel experience.</h3>
              <div className="video-block">
                <iframe title="vimeo-player" src="https://player.vimeo.com/video/681887225?h=4f3f8bcbea" width="100%"
                        height="600" frameBorder="0" allowFullScreen></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </div>*/}
    </div>
  )
}

export default AboutUs;
